// Autogenerated file
export const routeTypesEnum = {
    Main: "Main",
    EmptyMileage: "EmptyMileage",
};
export const routeTypes = [
    { label: "Основной", value: "Main" },
    { label: "Порожний", value: "EmptyMileage" },
];
